import { lazy } from "react";

import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import RoleGuard from "utils/route-guard/RoleGuard";

const DashboardDefault = Loadable(
  lazy(() => import("views/dashboard/Default")),
);
const DashboardSmartTyping = Loadable(
  lazy(() => import("views/dashboard/SmartTypingOverview")),
);
const FinanceAnalytics = Loadable(
  lazy(() => import("views/dashboard/FinanceAnalytics")),
);
const VisitorAnalytics = Loadable(
  lazy(() => import("views/dashboard/VisitorAnalytics")),
);
const CourseManager = Loadable(
  lazy(() => import("views/smarttyping/CourseManager")),
);
const CouponManager = Loadable(
  lazy(() => import("views/smarttyping/CouponManager")),
);
const BundleManager = Loadable(
  lazy(() => import("views/smarttyping/BundleManager")),
);
const StudentInsights = Loadable(
  lazy(() => import("views/smarttyping/StudentInsights")),
);
const CohortPipeline = Loadable(
  lazy(() => import("views/smarttyping/CohortPipeline")),
);
const AdminDirectory = Loadable(
  lazy(() => import("views/admin/AdminDirectory")),
);
const AuditLogs = Loadable(lazy(() => import("views/admin/AuditLogs")));
const MenuPermissionMatrix = Loadable(
  lazy(() => import("views/admin/MenuPermissionMatrix")),
);
const FeatureFlags = Loadable(lazy(() => import("views/admin/FeatureFlags")));
const RoleTemplateManager = Loadable(
  lazy(() => import("views/admin/RoleTemplateManager")),
);
const SchoolTenantManager = Loadable(
  lazy(() => import("views/smarttyping/SchoolTenantManager")),
);
const SubscriptionManager = Loadable(
  lazy(() => import("views/smarttyping/SubscriptionManager")),
);
const ContactInquiries = Loadable(
  lazy(() => import("views/smarttyping/ContactInquiries")),
);
const PracticePassageManager = Loadable(
  lazy(() => import("views/smarttyping/PracticePassageManager")),
);
const ArticleManager = Loadable(
  lazy(() => import("views/articles/ArticleManager")),
);
const ShopManager = Loadable(lazy(() => import("views/shop/ShopManager")));
const HeroVideoManager = Loadable(
  lazy(() => import("views/smarttyping/HeroVideoManager")),
);
const ReviewPostManager = Loadable(
  lazy(() => import("views/smarttyping/ReviewPostManager")),
);
const SnookyBalanceManager = Loadable(
  lazy(() => import("views/smarttyping/SnookyBalanceManager")),
);
const PaymentTransferReview = Loadable(
  lazy(() => import("views/smarttyping/PaymentTransferReview")),
);
const BankAccountManager = Loadable(
  lazy(() => import("views/smarttyping/BankAccountManager")),
);
const UserGuide = Loadable(lazy(() => import("views/guide/UserGuide")));

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    { path: "/dashboard/default", element: <DashboardDefault /> },
    { path: "/dashboard/smarttyping", element: <DashboardSmartTyping /> },
    { path: "/dashboard/analytics", element: <FinanceAnalytics /> },
    { path: "/dashboard/visitors", element: <VisitorAnalytics /> },
    { path: "/courses/manage", element: <CourseManager /> },
    { path: "/courses/coupons", element: <CouponManager /> },
    { path: "/courses/bundles", element: <BundleManager /> },
    { path: "/students/insights", element: <StudentInsights /> },
    { path: "/cohorts/pipeline", element: <CohortPipeline /> },
    { path: "/contact-inquiries", element: <ContactInquiries /> },
    { path: "/practice-passages", element: <PracticePassageManager /> },
    { path: "/site/hero-video", element: <HeroVideoManager /> },
    { path: "/site/review-post", element: <ReviewPostManager /> },
    { path: "/site/snooky-balance", element: <SnookyBalanceManager /> },
    { path: "/articles", element: <ArticleManager /> },
    { path: "/shop", element: <ShopManager /> },
    { path: "/payments/transfers", element: <PaymentTransferReview /> },
    {
      path: "/payments/bank-accounts",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <BankAccountManager />
        </RoleGuard>
      ),
    },
    { path: "/guide", element: <UserGuide /> },
    {
      path: "/admins",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <AdminDirectory />
        </RoleGuard>
      ),
    },
    {
      path: "/audit-logs",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <AuditLogs />
        </RoleGuard>
      ),
    },
    {
      path: "/menu-permissions",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <MenuPermissionMatrix />
        </RoleGuard>
      ),
    },
    {
      path: "/feature-flags",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <FeatureFlags />
        </RoleGuard>
      ),
    },
    {
      path: "/role-templates",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <RoleTemplateManager />
        </RoleGuard>
      ),
    },
    {
      path: "/schools/tenants",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <SchoolTenantManager />
        </RoleGuard>
      ),
    },
    {
      path: "/schools/subscriptions",
      element: (
        <RoleGuard allowedRoles={["superadmin"]}>
          <SubscriptionManager />
        </RoleGuard>
      ),
    },
  ],
};

export default MainRoutes;
